import { render, staticRenderFns } from "./UpdatePositionModal.vue?vue&type=template&id=09566a0a&scoped=true&"
import script from "./UpdatePositionModal.vue?vue&type=script&lang=js&"
export * from "./UpdatePositionModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePositionModal.vue?vue&type=style&index=0&id=09566a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09566a0a",
  null
  
)

export default component.exports